import { BackToOriginUrlParams } from 'components/back-to-origin-button/backToOriginButton-model'
import { buildBackToOriginParams, isBackToOriginKey } from 'components/back-to-origin-button/backToOriginButton-utils'
import { ACOMPANHAMENTO_TERRITORIO_PATH } from 'components/layout/SideMenu/SideMenuItems'

export const getCallbackTabByString = (tab: string) =>
  ['informacoes', 'visitas', 'familias'].includes(tab) ? tab : 'informacoes'

export const getBackToOriginSearch = ({ backToOriginUrl, backToOriginKey }: BackToOriginUrlParams = {}) => {
  if (!backToOriginUrl) return ''

  const validBackToOriginKey = isBackToOriginKey(backToOriginKey) ? backToOriginKey : undefined
  return buildBackToOriginParams(backToOriginUrl, validBackToOriginKey)
}

export const getVisualizacaoImovelCallbackUrl = (
  imovelId: string,
  callbackTabString: string,
  backToOrigin?: BackToOriginUrlParams
) => {
  const backToOriginSearch = getBackToOriginSearch(backToOrigin)

  return `${ACOMPANHAMENTO_TERRITORIO_PATH}/visualizarImovel/${imovelId}/${getCallbackTabByString(callbackTabString)}${
    backToOriginSearch ? `?${backToOriginSearch}` : ''
  }`
}

export const createImovelNotFoundError = (source: string, imovelId: string): Error =>
  new Error(`[${source}] Inconsistencia de dados: imovel nao encontrado para o id ${imovelId}.`)
